import { Button } from "antd";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import "./feature-log-navigator.scss";

export type FeatureLogNavigatorProps = {
  visible: boolean;
  currentIndex: number; // zero-based
  total: number;
  onPrev: () => void;
  onNext: () => void;
};

function FeatureLogNavigator({
  visible,
  currentIndex,
  total,
  onPrev,
  onNext
}: FeatureLogNavigatorProps) {
  if (!visible || total <= 0) return null;

  const prevDisabled = currentIndex <= 0;
  const nextDisabled = currentIndex < 0 || currentIndex >= total - 1;
  const displayIndex =
    currentIndex >= 0 ? currentIndex + 1 : Math.max(1, currentIndex + 1);

  return (
    <div
      className="feature-log-navigator"
      data-testid="feature-log-navigator-root"
    >
      <Button
        className="feature-log-navigator__btn feature-log-navigator__btn--prev"
        icon={<IconChevronLeft size={20} stroke={2} />}
        disabled={prevDisabled}
        onClick={onPrev}
        data-testid="feature-log-navigator-prev"
      >
        Previous
      </Button>
      <div
        className="feature-log-navigator__counter"
        data-testid="feature-log-navigator-counter"
      >
        {`${displayIndex} of ${total}`}
      </div>
      <Button
        className="feature-log-navigator__btn feature-log-navigator__btn--next"
        disabled={nextDisabled}
        onClick={onNext}
        data-testid="feature-log-navigator-next"
      >
        <span className="feature-log-navigator__next-label">
          Next
          <IconChevronRight size={20} stroke={2} />
        </span>
      </Button>
    </div>
  );
}

export default FeatureLogNavigator;
